// Use the injected environment variable directly at build time
//const env = process.env.REACT_APP_ENV || ''; // React will inject the value during build

// Construct the appropriate config file name based on the environment
//const configFile = env ? `/config.${env}.json` : '/config.json';

import('./AppBootstrap')
  .then(
    async ({ renderApp }) => {
      try {
        // Fetch the appropriate config file
        // Moved below to authConfig, as it seems pure java scripts execute before index.tsx
        // const response = await fetch('/config.json');
        // const config = await response.json();  
        // (window as any)["runConfig"] = config;

        // Render the app after the config is loaded
        await renderApp();
      } catch (error) {
        console.error("Error loading configuration file:", error);
      }
    }
  )
  .catch((error) => {
    console.error("Error importing AppBootstrap:", error);
  });

export { };
